export const PROGRESS_RANGE = {
    MIN: 0,
    MAX: 100,
};
